import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from 'src/app/core/services/base.service';
import { catchError, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class LocaleService extends BaseService {
    constructor(private http: HttpClient) {
        super();
    }

    getCountries() {
        const body = this.setBody();

        return this.http
            .post(this.urlService + this.routeAdress.route_locale_country, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));
    }

    getStates(countryId?) {
        const body = this.setBody();
        if (countryId) {
            body.set('countryId', countryId);
        }
        return this.http
            .post(this.urlService + this.routeAdress.route_locale_state, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));
    }

    getCities(stateId) {
        const body = this.setBody();
        body.set('stateId', stateId);
        return this.http
            .post(this.urlService + this.routeAdress.route_locale_city, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));
    }

    /**
     * getLocales()
     * faz requisição de cidades, estados e paises
     * e retorna objeto com todos os dados
     * TODO: Tratar erros
     * ? mover tudo para um objeto 'locale' dentro do try-catch
     */
    async getLocales({ stateId, countryId }) {
        const countriesRes = await this.getCountries().toPromise();
        const statesRes = await this.getStates(countryId).toPromise();
        const citiesRes = await this.getCities(stateId).toPromise();

        return {
            cities: citiesRes.registers,
            states: statesRes.registers,
            countries: countriesRes.registers,
        };
    }
}
